import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { TprAddCommentComponent } from './tpr-add-comment/tpr-add-comment.component';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { CgpConfirmationDialogService } from '../../../../../../app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';

import { ToastrService } from 'ngx-toastr';
import { TprCommentApiService } from './tpr-comment-modal.service';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { ColumnDef, PageOptions } from '../../../../../shared/data-table/data-table.interface';
import { finalize, filter } from 'rxjs/operators';
import { DataTableValidators } from 'src/app/shared/data-table/validators';

@Component({
   selector: 'tpr-comment-modal',
   templateUrl: './tpr-comment-modal.template.html',
   styleUrls: ['../../../tprecm.style.scss', './tpr-comment-modal.scss']
})
export class TprCommentModalComponent {

   selectedComment;
   comments: any[];
   total;
   loading = false;

   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('commDate');

   /**
    * Column names and values for the tprComments table.
    * Matches the DTO.
    *
    * @type {any[]}
    * @memberof TprCommentModalComponent
    */
   columns: ColumnDef[] = [
      { field: 'commDate', name: 'Date', type: 'date', width: '15%' },
      { field: 'comment', name: 'Comment', width: '85%', validators: DataTableValidators.maxLength(400) },
   ];

   constructor(
      private readonly dialogRef: MatDialogRef<TprCommentModalComponent>,
      private readonly toastr: ToastrService,
      private readonly service: TprCommentApiService,
      private readonly confirmation: CgpConfirmationDialogService,
      private readonly dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly dataTableService: DataTableService
   ) { }

   loadComments() {
      this.loading = true;
      this.service.getTprComments(this.data.selectedToolId, this.pageOptions)
         .pipe(finalize(() => this.loading = false))
         .subscribe(
            response => {
               this.comments = response.data;
               this.total = response.totalCount;
            }
         );

      this.selectedComment = null;
   }

   onGridSelectionChange(event) {
      this.selectedComment = event;
   }

   onLazyLoad(event: LazyLoadEvent) {
      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = event.sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;

      this.loadComments();
   }

   onAddCommentClick() {
      const dialogRef = this.dialog.open(TprAddCommentComponent, {
         disableClose: true,
         data: this.data.selectedToolId,
      });

      this.selectedComment = null;

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => {
            this.pageOptions.sort = 'id';
            this.pageOptions.order = 'desc';
            this.loadComments();
         });
   }

   removeHandler() {
      if (!this.selectedComment) {
         this.toastr.error('Please select a comment to remove');
         return;
      }

      this.confirmation.showConfirmationDialog({
         title: 'TPRECM',
         message: `Are you sure you want to delete this comment?<br/><br/>${this.selectedComment.comment}`,
         alert: 'danger',
         width: '425px',
         onYesClick: () => {
            this.service.deleteTprComment(this.data.selectedToolId, this.selectedComment.id)
               .pipe(finalize(() => this.loadComments()))
               .subscribe();

            this.confirmation.closeConfirmationDialog();
         },
         onNoClick: () => this.confirmation.closeConfirmationDialog()
      });
   }

   saveHandler(dataItem) {
      this.service.updateTprComment(this.data.selectedToolId, dataItem.data)
         .pipe(finalize(() => this.loadComments()))
         .subscribe();
   }
}
